import React from 'react';
import ApprovalsByRole from '../ApprovalsByRole';
import Heading from '@hubins/components/Heading';

const ApprovalsQuantumCompliance = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>Quantum Compliance</Heading>
      <ApprovalsByRole role="quantum_compliance" />
    </>
  );
};

export default ApprovalsQuantumCompliance;
